var _rect, _desc, _defs, _title, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamond2310(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232.32,
    height: 283.9467,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "selected"
  })), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), /*#__PURE__*/React.createElement("g", {
    id: "9c786676-d922-46a2-bec9-24d3952492eb",
    opacity: 1
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255, 255, 255)",
      fillRule: "nonzero",
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: 4462.442869458008,
    y: 4664.398681640625,
    rx: 0,
    ry: 0,
    width: 2880,
    height: 2880,
    transform: "matrix(0.1777776, 0.0, 0.0, 0.2024848, 1019.8373333333334, 963.184)",
    strokeWidth: 0,
    id: "svg_1",
    opacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fc93e9d1-ec0d-417e-aeb2-2c4f2c8e660e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#24282c",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "27.426666666666673,141.97333333333333 116.16000000000003,19.101756105673832 204.89333333333337,141.97333333333333 116.16000000000003,264.8449166870118 27.426666666666673,141.97333333333333",
    strokeWidth: 0,
    id: "svg_3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond2310);
export default __webpack_public_path__ + "static/media/diamond-2-3-10.21d9b7a232e05f06f8a2b4ce15938b4d.svg";
export { ForwardRef as ReactComponent };